import { z } from 'zod';

export const KvkkCompanySchema = z.object({
    id: z.union([z.string(), z.number()]).optional(),
    name: z.string().min(1),
    taxNumber: z.string().optional(),
    customFields: z.record(z.unknown()).optional(),
});

export const CreateKvkkCompanySchema = KvkkCompanySchema.omit({ id: true });
export const UpdateKvkkCompanySchema = KvkkCompanySchema;
export const KvkkCompanyFormSchema = z.object({
    domesticDataController: z.record(z.any()).optional(),
    foreignDataController: z.record(z.any()).optional(),
    foreignDataControllerRepresentative: z.record(z.any()).optional(),
    publicInstitution: z.record(z.any()).optional(),
    kvkkTeam: z.record(z.any()).optional(),
    documentApprover: z.record(z.any()).optional(),
}).passthrough();

export const KVKKCompanySchema = KvkkCompanySchema;
export const CreateKVKKCompanySchema = CreateKvkkCompanySchema;
export const UpdateKVKKCompanySchema = UpdateKvkkCompanySchema;
export const KVKKCompanyFormSchema = KvkkCompanyFormSchema;